import styled from 'styled-components';

import { BrandAffinityLevelsTable } from './BrandAffinityLevelsTable';
import { CustomDemographicInsightsSection } from './CustomDemographicInsightsSection';
import { DevicesTable } from './DevicesTable';
import { EmailDomainsTable } from './EmailDomainsTable';
import { InsightsSection } from './InsightsSection';
import { LocalesTable } from './LocalesTable';
import { LocationsMap } from './LocationsMap';
import { useProfileQueryContext, CustomDemographicContextProvider } from './contexts';
import { InsightType } from '../domain';
import { ContactPropertySelect } from './ContactPropertySelect';

const ToolbarWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: end;
`;

export const TOOLBAR_DATA_TEST = 'demographic-insights-toolbar';

const Toolbar = () => (
  <ToolbarWrapper data-test={TOOLBAR_DATA_TEST}>
    <ContactPropertySelect />
  </ToolbarWrapper>
);

export const DemographicInsightsSection = () => {
  const { isProfileLoading } = useProfileQueryContext();

  const toolbar = <Toolbar />;

  return (
    <CustomDemographicContextProvider>
      <InsightsSection
        type={InsightType.demographics}
        isLoading={isProfileLoading}
        toolbar={toolbar}
      >
        <CustomDemographicInsightsSection />
        <DevicesTable />
        <EmailDomainsTable />
        <BrandAffinityLevelsTable />
        <LocalesTable />
        <LocationsMap />
      </InsightsSection>
    </CustomDemographicContextProvider>
  );
};
